var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { BackendService } from './backend.service';
import { UserService } from './user.service';
export var TeamMembershipStatus;
(function (TeamMembershipStatus) {
    TeamMembershipStatus["MEMBER"] = "member";
    TeamMembershipStatus["INVITATION"] = "invitation";
    TeamMembershipStatus["APPLICATION"] = "application";
    TeamMembershipStatus["NONE"] = "none";
})(TeamMembershipStatus || (TeamMembershipStatus = {}));
/**
 * Handles challenge related tasks.
 */
var ChallengeService = (function () {
    function ChallengeService(backendService, userService) {
        var _this = this;
        this.backendService = backendService;
        this.userService = userService;
        // Flag which indicates that no challenges have been found, additionally to displayedChallenge subject
        this.noChallengeFound = false;
        // The challenge that should be displayed in the app (Only one challenge should be displayed at any given time)
        // Use replay subjects in order for it to not emit on component initialization
        this.displayedChallenge = new ReplaySubject(1);
        this.currentChallengeId = null;
        // All teams for the currently displayed challenge
        this.teams = new ReplaySubject(1);
        // Team of user for the currently displayed challenge
        this.team = new ReplaySubject(1);
        // User object in team of currently displayed challenge
        this.teamUser = new ReplaySubject(1);
        this.userService.currentUser.subscribe(function (user) {
            if (!user) {
                return;
            }
            _this.user = user;
            _this.noChallengeFound = false;
            var query = {};
            if (user.company) {
                query.companyID = user.company._id;
            }
            if (user.branchoffice) {
                query.branchofficeID = user.branchoffice._id;
            }
            _this.backendService.get("challenge", query).then(function (challenges) {
                _this.filterChallenges(challenges);
            });
        });
    }
    /**
     * Reloads teams for the currently active challenge
     */
    ChallengeService.prototype.reloadTeams = function () {
        return __awaiter(this, void 0, void 0, function () {
            var teams, _i, teams_1, team, group, newTeam, newTeamUser, _a, teams_2, team, _b, _c, teamUser, _d, teams_3, team, _e, _f, teamUser, _g, teams_4, team, _h, _j, teamUser, error_1;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!this.currentChallengeId) return [3 /*break*/, 4];
                        _k.label = 1;
                    case 1:
                        _k.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.backendService.get("challenge/" + this.currentChallengeId + "/team")];
                    case 2:
                        teams = _k.sent();
                        if (!teams || teams.length === 0) {
                            this.teams.next([]);
                            this.team.next(null);
                            this.teamUser.next(null);
                            return [2 /*return*/];
                        }
                        // Enhance team model by dividing users into different groups
                        for (_i = 0, teams_1 = teams; _i < teams_1.length; _i++) {
                            team = teams_1[_i];
                            group = this.splitUserGroups(team);
                            team.userGroups = group;
                        }
                        this.teams.next(teams);
                        newTeam = null;
                        newTeamUser = null;
                        // Check if the user has member status in any team
                        for (_a = 0, teams_2 = teams; _a < teams_2.length; _a++) {
                            team = teams_2[_a];
                            for (_b = 0, _c = team.userGroups.members; _b < _c.length; _b++) {
                                teamUser = _c[_b];
                                if (this.user && teamUser._id === this.user._id) {
                                    newTeam = team;
                                    newTeamUser = teamUser;
                                }
                            }
                        }
                        if (!newTeam) {
                            // Check if user has application status in any team
                            for (_d = 0, teams_3 = teams; _d < teams_3.length; _d++) {
                                team = teams_3[_d];
                                for (_e = 0, _f = team.userGroups.applications; _e < _f.length; _e++) {
                                    teamUser = _f[_e];
                                    if (this.user && teamUser._id === this.user._id) {
                                        newTeam = team;
                                        newTeamUser = teamUser;
                                    }
                                }
                            }
                        }
                        if (!newTeam) {
                            // Check if user has invitation status in any team
                            for (_g = 0, teams_4 = teams; _g < teams_4.length; _g++) {
                                team = teams_4[_g];
                                for (_h = 0, _j = team.userGroups.invitations; _h < _j.length; _h++) {
                                    teamUser = _j[_h];
                                    if (this.user && teamUser._id === this.user._id) {
                                        newTeam = team;
                                        newTeamUser = teamUser;
                                    }
                                }
                            }
                        }
                        this.team.next(newTeam);
                        this.teamUser.next(newTeamUser);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _k.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Removes a user from the specified team
     */
    ChallengeService.prototype.removeUserFromTeam = function (challengeID, teamID, userID) {
        var _this = this;
        return this.backendService.put("challenge/" + challengeID + "/team/" + teamID + "/user/" + userID + "/leave").then(function (result) {
            _this.reloadTeams();
        });
    };
    /**
     * Removes a user from the specified team
     */
    ChallengeService.prototype.declineInvitation = function (challengeID, teamID, invitedEmail) {
        var _this = this;
        return this.backendService.put("challenge/" + challengeID + "/team/" + teamID + "/invitation/cancel", { email: invitedEmail }).then(function (result) {
            _this.reloadTeams();
        });
    };
    /**
     * Checks whether a user is theoretically able to be invited to the team. But does not send invitation yet.
     */
    ChallengeService.prototype.checkUserEligibility = function (challengeID, teamID, email) {
        return this.backendService.get("challenge/" + challengeID + "/team/" + teamID + "/checkEligibility/" + email);
    };
    /**
     * Invites a user to the specified team
     * @emails - list of emails of users that should be invited
     */
    ChallengeService.prototype.inviteUsers = function (challengeID, teamID, emails) {
        var _this = this;
        return this.backendService.put("challenge/" + challengeID + "/team/" + teamID + "/invitation/create", { emails: emails }).then(function (result) {
            _this.reloadTeams();
        });
    };
    /**
     * Cheer for another team member in an ongoing challenge
     */
    ChallengeService.prototype.cheerForTeamMember = function (challengeID, teamID, userID) {
        return this.backendService.put("challenge/" + challengeID + "/team/" + teamID + "/cheer/" + userID).then(function (result) { });
    };
    /**
     * Accept invitation to the specified team (triggered by invited user)
     */
    ChallengeService.prototype.acceptInvitation = function (challengeID, teamID, userID) {
        var _this = this;
        return this.backendService.put("challenge/" + challengeID + "/team/" + teamID + "/invitation/accept", { userID: userID }).then(function (result) {
            _this.reloadTeams();
        });
    };
    /**
     * Accepts application of a user to the team (triggered by team founder)
     */
    ChallengeService.prototype.acceptApplication = function (challengeID, teamID, userID) {
        var _this = this;
        return this.backendService.put("challenge/" + challengeID + "/team/" + teamID + "/application/accept", { userID: userID }).then(function (result) {
            _this.reloadTeams();
        });
    };
    /**
     * Cancels the application of a user for a team
     */
    ChallengeService.prototype.cancelApplication = function (challengeID, teamID, userID) {
        var _this = this;
        return this.backendService.put("challenge/" + challengeID + "/team/" + teamID + "/application/cancel", { userID: userID }).then(function (result) {
            _this.reloadTeams();
        });
    };
    /**
     * Send an application to join the specified team
     * @param challengeID Challenge the team takes part in
     * @param teamID Team user wishes to join
     */
    ChallengeService.prototype.applyForTeam = function (challengeID, teamID) {
        var _this = this;
        return this.backendService.put("challenge/" + challengeID + "/team/" + teamID + "/application/create").then(function (result) {
            _this.reloadTeams();
        });
    };
    /**
     * Creates a team for the given challenge with the given values
     * @param teamValues - values of team that should be created
     */
    ChallengeService.prototype.createTeam = function (challengeID, teamValues) {
        var _this = this;
        return this.backendService.post("challenge/" + challengeID + "/team", teamValues).then(function (team) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reloadTeams()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, team];
                }
            });
        }); });
    };
    /**
     * Deletes the specified team
     */
    ChallengeService.prototype.deleteTeam = function (challengeID, teamID) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.backendService.delete_("challenge/" + challengeID + "/team/" + teamID)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.reloadTeams()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sets currentChallenge, nextChallenge and pastChallenges based on passed challenges.
     * Decides which challenge should be displayed throughout the app, since only one should be displayed at the same time.
     */
    ChallengeService.prototype.filterChallenges = function (challenges) {
        if (!challenges) {
            this.noChallengeFound = true;
            return;
        }
        // Only past challenges that ended during the last 14 days are used
        var pastChallenges = challenges
            .filter(function (challenge) { return moment().isAfter(moment(challenge.end)) && moment(challenge.end).add(7, 'days').isAfter(moment()); })
            .sort(function (a, b) { return (moment(a.end).isBefore(moment(b.end)) ? 1 : -1); });
        var currentChallenges = challenges
            .filter(function (challenge) { return moment().isAfter(moment(challenge.start)) && moment().isBefore(moment(challenge.end)); })
            .sort(function (a, b) { return (moment(a.start).isBefore(moment(b.start)) ? 1 : -1); });
        var futureChallenges = challenges
            .filter(function (challenge) { return moment().isBefore(moment(challenge.start)) && (!challenge.preparation || moment().isAfter(challenge.preparation)); })
            .sort(function (a, b) { return (moment(a.start).isBefore(moment(b.start)) ? 1 : -1); });
        // Decide which challenge should be displayed throughout the app
        var challengeToDisplay = null;
        if (currentChallenges && currentChallenges.length > 0) {
            challengeToDisplay = currentChallenges[0];
        }
        if (!challengeToDisplay && futureChallenges && futureChallenges.length > 0) {
            challengeToDisplay = futureChallenges[0];
        }
        if (!challengeToDisplay && pastChallenges && pastChallenges.length > 0) {
            challengeToDisplay = pastChallenges[0];
        }
        if (challengeToDisplay) {
            this.displayedChallenge.next(challengeToDisplay);
            this.currentChallengeId = challengeToDisplay._id;
            this.reloadTeams();
        }
        else {
            this.noChallengeFound = true;
            this.displayedChallenge.next(null);
            this.currentChallengeId = null;
            this.teams.next(null);
            this.team.next(null);
            this.teamUser.next(null);
        }
    };
    /**
     * Splits the users of the team into different membership groups
     */
    ChallengeService.prototype.splitUserGroups = function (team) {
        if (!team) {
            return;
        }
        var userGroups = {
            invitations: [],
            applications: [],
            members: [],
        };
        // Divide users into different arrays based on their membership status
        for (var _i = 0, _a = team.users; _i < _a.length; _i++) {
            var user = _a[_i];
            if (user.membershipStatus === TeamMembershipStatus.MEMBER) {
                userGroups.members.push(user);
            }
            if (user.membershipStatus === TeamMembershipStatus.INVITATION) {
                userGroups.invitations.push(user);
            }
            if (user.membershipStatus === TeamMembershipStatus.APPLICATION) {
                userGroups.applications.push(user);
            }
        }
        return userGroups;
    };
    return ChallengeService;
}());
export { ChallengeService };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/services/challenge.service.ts.pre-build-optimizer.js